query FileCabinetCommonData {

   companyBusinessUnits(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  companyDepartments(
    orderBy: [NAME_ASC, PRIMARY_KEY_ASC]
    filter: { _isSystemInternal: { notEqualTo: true } }
  ) {
    nodes {
      id
      name
    }
  }
  companyCurrencies(orderBy: ISO_CODE_ASC) {
    nodes {
      id
      isoCode
    }
  }
  fileCabinetDocumentTypes(orderBy: DOCUMENT_TYPE_ASC) {
    nodes {
      id
      documentType
    }
  }
  fileCabinetPools(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  fileCabinetProcessHistories(orderBy: REQUEST_DATE_DESC){
    nodes{
      id
      exportInfo
    }
  }
}
